/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EntitySortLevel = {
    expression: string;
    direction?: EntitySortLevel.direction;
};

export namespace EntitySortLevel {

    export enum direction {
        ASCENDING = 'ASCENDING',
        DESCENDING = 'DESCENDING',
    }


}

